import { render, staticRenderFns } from "./lotteryNumber.vue?vue&type=template&id=c7b2f64c"
import script from "./lotteryNumber.vue?vue&type=script&lang=js"
export * from "./lotteryNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports